import styled from '@emotion/styled';
import { Stack, Text, tokens } from '@hotjar/hotsauce';
import { GaugeChart } from './GaugeChart';
import { Trend } from './Trend';

const ChartContainer = styled.div`
  display: flex;
  min-width: 14px;
`;

const Title = styled(Text)`
  line-height: 14px;
`;

const CoverageLabel = styled(Stack)`
  align-items: center;
  gap: ${tokens.spacer.x1};
`;

type Props = {
  title: string;
  subtitle: string;
  coverage: number;
  lossRate?: number;
};

export function Coverage({ title, subtitle, coverage, lossRate }: Props): JSX.Element {
  const showTrend = lossRate != null;

  return (
    <Stack customSpacing={tokens.spacer.x1}>
      <ChartContainer>
        <GaugeChart coverage={coverage} />
      </ChartContainer>
      <Stack direction="column" customSpacing={tokens.spacer.x1}>
        <CoverageLabel>
          <Title as="span" textType="subtitle1">
            {title}
          </Title>
          {showTrend ? <Trend value={lossRate} /> : null}
        </CoverageLabel>
        <Text as="span" textType="caption" textColor="text_default">
          {subtitle}
        </Text>
      </Stack>
    </Stack>
  );
}
